module.exports = __webpack_public_path__ + "img/check-o.3fb5c7a1.svg";